import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getReferentsScolarite() {
    const response = await axios.get("/api/admin/referentsScolarite");
    return response.data;
  },
  async updateReferentsScolarite(referents) {
    const response = await axios.put(
      "/api/admin/referentsScolarite",
      referents
    );
    return response.data;
  },
};
